module.exports = __webpack_public_path__ + "img/product-oil-modal.a283ddfc.png";